/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1653
 */

require(/* 86 */"./1650/86/index")({
  target: "Number",
  stat: true
}, {
  isNaN: function (e) {
    return e != e
  }
})
